import React from 'react';
import { Link } from 'react-router-dom';
import FacebookIcon from 'mdi-react/FacebookIcon';
import GooglePlusIcon from 'mdi-react/GooglePlusIcon';
import backGroundImage from '../../../images/login-poster-2.jpg';
import LogInForm from './components/PrintPickingDetailForm';

import logo from '../../../images/logo-leanbox-wms-new.png'

const PrintPickingDetail = () => (
  <div className="account" style={{backgroundColor: '#fff'
}}>
    <div className="login_left_container" style={{width: '60%', display: 'none', float:'left' , backgroundImage: `url(${backGroundImage})`}}>
      

    </div>
    <div className="account__wrapper" style={{width: '90%', float: 'left', marginTop: 20}}>
      
        
        <LogInForm onSubmit />
        <div className="account__or" style={{display: 'none'}}>
          <p>Or Easily Using</p>
        </div>
        <div className="account__social" style={{display: 'none'}}>
          <Link
            className="account__social-btn account__social-btn--facebook"
            to="/dashboard_default"
          ><FacebookIcon />
          </Link>
          <Link
            className="account__social-btn account__social-btn--google"
            to="/dashboard_default"
          ><GooglePlusIcon />
          </Link>
        </div>
      
    </div>
  </div>
);

export default PrintPickingDetail;
